import { unlessW } from '@infl-ts/util-function';
import * as Str from 'fp-ts/string';
import { hasProtocol } from './has-protocol';
export var addValidProtocol = unlessW(function (url) {
  return Str.isEmpty(url) || hasProtocol(url);
}, function (url) {
  return 'https://' + url;
});